'use client';

import { createContext } from 'react';

// PWA 설치 관련 컨텍스트 생성
export const PWAInstallContext = createContext<{
  deferredPrompt: any;
  isInstallable: boolean;
  isPWAInstalled: boolean;
  showInstallPrompt: () => Promise<void>;
}>({
  deferredPrompt: null,
  isInstallable: false,
  isPWAInstalled: false,
  showInstallPrompt: async () => { },
});
